export const GET_WEAPON_PENDING = "GET_WEAPON_PENDING";
export const GET_MORE_WEAPON_PENDING = "GET_MORE_WEAPON_PENDING";
export const GET_WEAPON_SUCCESS = "GET_WEAPON_SUCCESS";
export const GET_MORE_WEAPON_SUCCESS = "GET_MORE_WEAPON_SUCCESS";
export const RESET_WEAPON = "RESET_WEAPON";
export const GET_WEAPON_DETAILS = "GET_WEAPON_DETAILS";
export const RESET_WEAPON_DETAILS = "RESET_WEAPON_DETAILS";
